import { type SearchItem } from './search'

const textRow = (item: SearchItem): HTMLElement => {
  const wrap = document.createElement('span')

  wrap.className = 'progress-panel--select__option'
  wrap.appendChild(labelNode(item))

  return wrap
}

const linkRow = (item: SearchItem): HTMLAnchorElement => {
  const link = document.createElement('a')

  link.className = 'progress-panel--select__option'
  link.href = item.url ?? '#'
  link.appendChild(labelNode(item))

  return link
}

const buttonRow = (item: SearchItem): HTMLButtonElement => {
  const button = document.createElement('button')

  button.type = 'button'
  button.className = 'progress-panel--select__option'
  if (item.action) button.dataset.action = item.action
  button.appendChild(labelNode(item))

  return button
}

const nestedRow = (item: SearchItem): HTMLButtonElement => {
  const button = document.createElement('button')

  button.type = 'button'
  button.className = 'progress-panel--select__option progress-panel--select__option--nested'
  if (item.popover_id) button.setAttribute('popovertarget', item.popover_id)
  button.appendChild(labelNode(item))

  return button
}

const labelNode = (item: SearchItem): DocumentFragment => {
  const fragment = document.createDocumentFragment()
  const label = document.createElement('span')

  label.className = 'progress-panel--select__option-label'
  label.textContent = item.label ?? ''
  fragment.appendChild(label)

  if (item.subtitle) {
    const subtitle = document.createElement('small')

    subtitle.className = 'progress-panel--select__option-subtitle'
    subtitle.textContent = item.subtitle
    fragment.appendChild(subtitle)
  }

  return fragment
}

const fillTemplate = (template: HTMLTemplateElement, item: SearchItem): DocumentFragment => {
  const fragment = template.content.cloneNode(true) as DocumentFragment

  fragment.querySelectorAll<HTMLElement>('[data-field]').forEach(node => {
    const field = node.dataset.field as string

    if (item[field] !== undefined && item[field] !== null) node.textContent = String(item[field])
  })

  fragment.querySelectorAll<HTMLElement>('[data-href-field]').forEach(node => {
    const field = node.dataset.hrefField as string

    if (item[field] !== undefined && item[field] !== null) (node as HTMLAnchorElement).href = String(item[field])
  })

  return fragment
}

const rowRenderers: Record<string, (item: SearchItem) => HTMLElement> = {
  text: textRow,
  link: linkRow,
  button: buttonRow,
  nested: nestedRow
}

const nextOptionId = (() => {
  let counter = 0

  return () => `pp-select-option-${++counter}`
})()

export type RowOptions = {
  template?: HTMLTemplateElement | null
}

export function renderRow(item: SearchItem, options: RowOptions = {}): HTMLLIElement {
  const row = document.createElement('li')

  row.setAttribute('role', 'option')
  row.setAttribute('aria-selected', 'false')
  row.id = nextOptionId()
  row.dataset.type = item.type ?? 'text'
  if (item.id !== undefined && item.id !== null) row.dataset.id = String(item.id)
  row.dataset.label = item.label ?? ''

  if (options.template) {
    row.appendChild(fillTemplate(options.template, item))
    return row
  }

  const build = rowRenderers[item.type ?? 'text'] ?? textRow

  row.appendChild(build(item))

  return row
}
